<template>
	<div class="ui-menu">
		<div class="ui-menu-activator" @click.stop="toggleOpen">
			<slot name="activator"/>
		</div>
		<div v-show="open" class="ui-menu-content" ref="menuContent">
			<slot/>
		</div>
	</div>
</template>

<script>
export default {
	props: {

	},

	data: () => ({
		open: false
	}),

	created() {
		window.addEventListener('click', this.eventHandler);
	},

	destroyed() {
		window.removeEventListener('click', this.eventHandler);
	},

	methods: {
		eventHandler(e) {
			if (this.open) {
				this.open = Boolean(e.target.closest('.ui-menu-activator'));
			}
		},

		toggleOpen(e) {
			let yPos = e.y + 120 < window.innerHeight ? e.y + 15 : e.y - 140;
			let xPos = e.x + 230 < window.innerWidth ? e.x - 15 : window.innerWidth - 230;

			this.$refs.menuContent.style.left = `${xPos}px`;
			this.$refs.menuContent.style.top = `${yPos}px`;

			this.open = !this.open;
		}
	}
};
</script>

<style lang="scss">
.ui-menu {
	height: 100%;
	display: flex;
	position: relative;
}

.ui-menu-content {
	display: block;
	z-index: 8;
	margin-top: 3px;
	padding: 10px;
	background-color: white;
	border-radius: 3px;
	position: fixed;
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
}
</style>
